//
// extend core typewise
//
require('./collation')

module.exports = require('typewise-core/base')



//////////////////
// WEBPACK FOOTER
// ./node_modules/typewise/base.js
// module id = p9HQ
// module chunks = 70